import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getAnalyticsData } from "api/analytics.api";

export interface AnalyticsSlice {
  analytics_data: any;
  analytics_loading_status:number;
}

const initialState: AnalyticsSlice = {
  analytics_data: null,
  analytics_loading_status: 0,
};

export const doGetAnalyticsData = createAsyncThunk(
  "agreement/doGetAnalyticsData",
  async () =>
    getAnalyticsData().then((res: any) => {
      return res;
    })
);

const analyticsSlice = createSlice({
  name: "agreement",
  initialState,
  reducers: {},
    extraReducers: (builder) => {
      
        
    builder.addCase(doGetAnalyticsData.pending, (state, action) => {
      
        state.analytics_loading_status = 1;
    });
     builder.addCase(doGetAnalyticsData.fulfilled, (state, action) => {
        state.analytics_data = action.payload;
        state.analytics_loading_status = 2;
    });
    
   
  },
});

export default analyticsSlice.reducer;
